import { Props as BaseProps } from "@repo/dynamicEditor/src/helpers/sectionMapping";
import * as DEValidation from "@repo/dynamicEditor/src/helpers/validation";
import { ComponentValidationResult } from "@repo/dynamicEditor/src/models/mappedComponent";
import { MultiValidatorFn } from "@repo/helpers";
import { MvcLocation } from "@repo/models";

import { LocationStatus, Settings } from "../../models";
import {
	conditionalField as baseConditionalField,
	componentType,
	MappedComponent,
	MappedDyno,
} from "./components/portalDynamicComponent";

export function getValidator<T>(entity: T) {
	return function (component: MappedComponent): MultiValidatorFn<any, ComponentValidationResult> {
		// switch (component.propertyName) {
		//     case "repDiscipline.endDate":
		//         const startDate = (entity as any as RepDiscipline).startDate;
		//         if (startDate)
		//             return (v: Date) =>
		//                 v < startDate ? "must be after start date" : DEValidation.getValidator(component)(v);
		//         break;
		// }

		switch (component.type as any) {
			case componentType.entryAddress:
				return validateChildren as any;
		}
		return DEValidation.getValidator(component);

		function validateChildren() {
			return component.components.map((c) => {
				return {
					component: c,
					value: getValidator(entity)(c)(c.propertyValue),
				};
			});
		}
	};
}

type SegmentPart = string &
	keyof MvcLocation &
	{
		[K in keyof MvcLocation]: MvcLocation[K] extends number ? K : never;
	}[keyof MvcLocation];
const getSegmentPart = (propName: SegmentPart) => (location: MvcLocation) => location?.[propName] || -1;
const getStateId = getSegmentPart("stateId");

export const shouldBeDisplayed = (props: ValidationData) => (component: MappedDyno) => {
	return matchConditional(component.visibleFor, props, true);
};

export const matchConditional = DEValidation.getMatchConditional(matchConditionalInternal);
/**
 * Returns true if condition matches, and false if not
 * Returns default value if no condition set
 * @param condition Conditional field to check
 * @param props Full set of data to compare conditions against
 */
function matchConditionalInternal(condition: conditionalField, props: ValidationData) {
	const { location } = props;
	let matched = true;
	if (!condition) return matched;
	if (!condition.stateId && !condition.channelId && !condition.property) return matched;

	const stateId = getStateId(location);
	if (condition.stateId) matched = matched && condition.stateId.includes(stateId);

	return matched;
}

/** Updates conditional fields to map to properties inside section */
export const getSubSectionConditionalFor = DEValidation.getSubSectionConditionalFor;
export const getSectionConditionalFor = DEValidation.getSectionConditionalFor;

export interface ValidationData extends BaseProps {
	loaded: boolean;
	location: MvcLocation;
	statusHistory: LocationStatus;
	settings: Settings;
}

export interface conditionalField extends baseConditionalField {
	stateId?: number[];
}
